module.exports = __webpack_public_path__ + "media/images/avatar-9b435ca895f281627167170572453a31.jpg";